import { render, staticRenderFns } from "./CalendarActivityInfo.vue?vue&type=template&id=0d2aebac&scoped=true&"
import script from "./CalendarActivityInfo.vue?vue&type=script&lang=js&"
export * from "./CalendarActivityInfo.vue?vue&type=script&lang=js&"
import style0 from "./CalendarActivityInfo.vue?vue&type=style&index=0&id=0d2aebac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2aebac",
  null
  
)

export default component.exports